import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {GUIDE_SELECTION_OVERVIEW_WIDTH} from '@/theme/sizing'
import {theme} from '@/theme/theme'

type ClassAssistOverviewLayoutProps = {
  title: string
  description?: string
}

export const ClassAssistOverviewLayout: FC<
  React.PropsWithChildren<ClassAssistOverviewLayoutProps>
> = ({title, description, children}) => (
  <>
    <div className="wrapper">
      <Text variant={TextVariant.h2}>{title}</Text>
      {description && (
        <div className="description">
          <Text variant={TextVariant.text20} color={theme.palette.text.light}>
            {description}
          </Text>
        </div>
      )}
      {children}
    </div>

    <style jsx>{`
      .wrapper {
        max-width: ${GUIDE_SELECTION_OVERVIEW_WIDTH};
        margin: 0 auto;
      }
      .description {
        margin-top: ${theme.spacing[3]};
      }
    `}</style>
  </>
)
